export const getDataParam = (integrationName: string) => {
  switch (integrationName) {
    case "skyscanner":
      return "sk";
    case "kiwi":
      return "kiwi";
    case "amadeus-generic":
      return "amadeus";
    case "amadeus-latam":
      return "latam";
    case "chalinga":
      return "chalinga";
    case "zupper":
      return "zupper";
    case "latamz":
      return "latam";
    case "golz":
      return "gol";
    case "capo":
      return "capo";
    case "vaiDePromo":
      return "vaiDePromo";
    case "flipmilhas":
      return "flipmilhas";
    case "ourtrip":
      return "ourtrip";
    case "123milhas":
      return "123milhas";
    case "maxmilhas":
      return "maxmilhas";
    case "viaza":
      return "viaza";
  }
};
